import API from '../../../helpers/request/api';

const api = () => new API();

const search = (filter, projectId, page) => {
  const query = {
    variables: { filter },
    query: `{
      posts_by_filter(
        filter: "${filter.trim()}",
        project_id: ${projectId},
        page: ${page}
      ) {
        id
        title
        description
        slug
        tags {
          tag
        }
      }
    }`,
  };

  return api().get(query);
};

const count = (filter, projectId) => {
  const query = {
    variables: { filter },
    query: `{
      posts_by_filter_count(
        filter: "${filter}",
        project_id: ${projectId}
      ) { }
    }`,
  };

  return api().get(query);
};

export default {
  search,
  count,
};



// WEBPACK FOOTER //
// ./src/screens/Search/queries/search.js